import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem("bb_admin_token");
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const trackVisit = (page = "landing") =>
  api.post("/analytics/visit", { page, referrer: document.referrer }).catch(() => {});

export const trackVideo = (event, percent = 0, label = "main") =>
  api.post("/analytics/video", { event, percent, label }).catch(() => {});

export const trackCtaClick = (label = "cta", page = "landing") =>
  api.post("/analytics/cta", { label, page }).catch(() => {});

export const joinCommunity = (email, name, source) =>
  api.post("/community/join", { email, name, source }).then((r) => r.data);

export const createOrder = (pkg) => api.post("/orders/create", { package: pkg }).then((r) => r.data);
export const getOrder = (orderId) => api.get(`/orders/${orderId}`).then((r) => r.data);
export const setOrderCustomer = (orderId, info) =>
  api.patch(`/orders/${orderId}/customer`, info).then((r) => r.data);
export const requestEmailDelivery = (orderId, email) =>
  api.post(`/orders/${orderId}/send-email`, { email }).then((r) => r.data);

// Geidea (Egypt) helpers
export const createGeideaSession = (orderId) =>
  api.post(`/orders/${orderId}/geidea-session`).then((r) => r.data);
export const confirmGeideaPayment = (orderId, geideaData) =>
  api.post(`/orders/${orderId}/geidea-confirm`, geideaData).then((r) => r.data);
